import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  row: {
    display: "flex",
    gap: "12px",
    alignItems: "flex-end",
    width: "100%",
    minWidth: 0,
  },
  grid3: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: "12px",
    width: "100%",
    direction: "rtl",
  },
  grid4: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: "12px",
    width: "100%",
    direction: "rtl",
  },
  gridStructureDoors: {
    display: "grid",
    gridTemplateColumns: "1fr 100px 1fr 100px",
    gap: "12px",
    width: "100%",
    alignItems: "end",
    direction: "rtl",
  },
  grid5: {
    display: "grid",
    gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
    gap: "12px",
    width: "100%",
    direction: "rtl",
  },
  grid6: {
    display: "grid",
    gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
    gap: "12px",
    width: "100%",
    direction: "rtl",
  },
  gridOverhang: {
    display: "grid",
    gridTemplateColumns: "2fr 0.4fr 1fr",
    gap: "12px",
    width: "100%",
    direction: "rtl",
  },
  overhangRow: {
    display: "flex",
    gap: "10px",
    alignItems: "flex-end",
    width: "100%",
    minWidth: 0,
    direction: "rtl",
  },
  overhangStatic: {
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "140%",
    color: theme.palette.secondary.main,
    padding: "0 8px",
    whiteSpace: "nowrap",
  },
  overhangSeparator: {
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "140%",
    color: theme.palette.secondary.main,
    padding: "0 4px",
  },
  cogRow: {
    display: "flex",
    gap: "10px",
    alignItems: "flex-end",
    width: "100%",
    minWidth: 0,
    direction: "rtl",
  },
  cogMainField: {
    flex: 1,
    minWidth: 0,
    direction: "rtl",
  },
  cogRangeGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    flexShrink: 0,
    direction: "rtl",
    alignItems: "flex-start",
  },
  cogRangeLabel: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "80%",
    margin: 0,
    padding: 0,
    color: theme.palette.text.primary,
    textAlign: "right",
    direction: "rtl",
    display: "block",
    width: "100%",
  },
  cogRangeFields: {
    display: "flex",
    gap: "10px",
    alignItems: "flex-end",
    direction: "rtl",
  },
  cogSeparator: {
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    direction: "rtl",
  },
  cogSeparatorText: {
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "140%",
    color: theme.palette.secondary.main,
    padding: "0 4px",
  },
  gridRoofOpenings: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr auto 1fr 1fr 1fr 1fr",
    gap: "12px",
    width: "100%",
    alignItems: "end",
    direction: "rtl",
  },
  actionButtons: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    height: 48,
    flexShrink: 0,
  },
  actionColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    flexShrink: 0,
    direction: "rtl",
    alignItems: "flex-start",
  },
  structureRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    width: "100%",
    alignItems: "stretch",
    direction: "rtl",
  },
  structurePanel: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    height: 128,
    minHeight: 128,
    padding: "12px",
    borderRadius: "4px",
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.info.light,
    direction: "rtl",
    alignItems: "stretch",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  structureCheckboxRow: {
    display: "flex",
    flexDirection: "row",
    direction: "rtl",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "8px",
    width: "100%",
  },
  structureCommentField: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    width: "100%",
    minWidth: 0,
    direction: "rtl",
    alignItems: "stretch",
  },
  structureCommentInput: {
    "& .MuiOutlinedInput-root": {
      height: 48,
      minHeight: 48,
      maxHeight: 48,
      alignItems: "center",
    },
  },
  labelSpacer: {
    height: "9.6px",
    margin: 0,
    padding: 0,
    visibility: "hidden",
  },
  fieldValue: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "140%",
    letterSpacing: 0,
    textAlign: "right",
    verticalAlign: "middle",
    leadingTrim: "cap-height",
    color: theme.palette.secondary.main,
  },
  checkboxBox: {
    display: "flex",
    flexDirection: "row",
    direction: "rtl",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "8px",
    height: 48,
    width: "100%",
    padding: "12px 16px 12px 8px",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "4px",
    backgroundColor: theme.palette.background.paper,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    alignSelf: "stretch",
  },
  btn: {
    height: 48,
    minHeight: 48,
    maxHeight: 48,
    padding: "12px 16px 12px 8px",
    borderRadius: "4px",
    borderWidth: "1px",
    textTransform: "none",
    fontFamily: theme.typography.fontFamily,
    fontSize: "13px",
    fontWeight: 600,
    lineHeight: "24px",
    whiteSpace: "nowrap",
    flexShrink: 0,
    boxSizing: "border-box",
  },
}));
